// src/api/client.ts
import axios, { AxiosInstance, AxiosError } from 'axios';
import { getApiBaseUrl } from './config';
import { AuthService } from './auth-service';

export class ApiClient {
  private static instance: AxiosInstance | null = null;

  private constructor() {} // Prevent instantiation

  public static async getInstance(): Promise<AxiosInstance> {
    if (!this.instance) {
      const baseURL = await getApiBaseUrl();
      
      this.instance = axios.create({
        baseURL,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Request interceptor
      this.instance.interceptors.request.use(
        async (config) => {
          try {
            const token = await AuthService.getAuthToken();
            config.headers.Authorization = `Bearer ${token}`;
            return config;
          } catch (error) {
            // Auth error already handled by AuthService
            return Promise.reject(error);
          }
        },
        (error: AxiosError) => {
          return Promise.reject(error);
        }
      );

      // Response interceptor
      this.instance.interceptors.response.use(
        (response) => response,
        (error: AxiosError) => {
          if (error.response?.status === 401) {
            AuthService.handleAuthError(error);
            return Promise.reject(error);
          }
          return Promise.reject(error);
        }
      );
    }
    return this.instance;
  }
}

export default ApiClient;
